import { Route } from '@angular/router';
import { LineSelectionComponent } from '@features/activity-types/travel-request/line-selection/line-selection.component';
import { TravelDetailsComponent } from '@features/activity-types/travel-request/travel-details/travel-details.component';
import { FinalizeOrderComponent } from '@features/shopping/finalize-order/finalize-order.component';
import { ReviewComponent } from '@features/shopping/review/review.component';

export const travel_request_routes: Route[] = [
  {
    path: 'line-selection',
    component: LineSelectionComponent,
    title: 'Select Line',
    data: { order_type_id: 6 }
  },
  {
    path: 'travel-details',
    component: TravelDetailsComponent,
    title: 'Travel Details',
    data: { order_type_id: 6 }
  },
  {
    path: 'finalize-order',
    component: FinalizeOrderComponent,
    title: 'Finalize Your Order',
    data: { order_type_id: 6 }
  },
  {
    path: 'review/:id',
    component: ReviewComponent,
    title: 'Review Your Order',
    data: { order_type_id: 6 }
  },
  {
    path: '',
    redirectTo: 'line-selection',
    pathMatch: 'full'
  }
];
